export class AppError extends Error {
  constructor(...args: string[]) {
    super(...args);
    this.name = "AppError";
  }
}
